import VueRouter from 'vue-router'

import Events from './components/Events'
import Contacts from './components/Contacts'
import Confirm from './components/Confirm'
import Payment from './components/Pay'
import Success from './components/Success'
import Wrong from './components/Wrong'
import Direction from "./components/Directions";

const routes = [
    { path: '/', component: Direction, name: 'directions'},
    { path: '/:slug', component: Events, name: 'events'},
    { path: '/:slug/:eventId/contacts', component: Contacts, name: 'contacts' },
    { path: '/:slug/:eventId/confirm', component: Confirm, name: 'confirm' },
    { path: '/:slug/:eventId/pay', component: Payment, name: 'pay' },
    { path: '/:slug/:eventId/success', component: Success, name: 'success' },
    { path: '/:slug/:eventId/wrong', component: Wrong, name: 'wrong' },
];

export default new VueRouter({
    mode: 'history',
    routes
});
